import { AuthenticatorSmsSetup } from "@/components/Welcome/AuthenticatorSetup/AuthenticatorSmsSetup";

export const TwoFactorInitialSmsSetupView = () => (
  <div className="max-w-[560px]">
    <AuthenticatorSmsSetup />
  </div>
);
